export default __webpack_public_path__ + "static/media/nextArrow.c619981b.svg";